export default function NotCheckedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 19H19V5H5V19ZM19 21H5C3.896 21 3 20.104 3 19V5C3 3.895 3.896 3 5 3H19C20.104 3 21 3.895 21 5V19C21 20.104 20.104 21 19 21Z"
        fill="currentColor"
      />
    </svg>
  );
}
